import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import getLocale from '../../i18n/getLocale';

class EmailDrowsinessScheduleTest extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      message: '',
      status: 'respondido',
    };
    // Handlers
    this.edit = this.edit.bind(this);
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    self.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/sonolencia/teste/status/'+self.props.match.params.token;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({
            status: responseJson.data,
          });
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      token: this.props.match.params.token,
      hour_start: this.state.hour_start,
      fatigue: this.state.fatigue,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/sonolencia/teste/reposta', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            status: 'respondido',
          });
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  render() {
    return (
<div className="user-wrapper">
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="user-layer-suspended">
    <div className="container-liquid">
      <div className="conteudo">
        <h3 className="page-title">{this.locale.Usuarios.TesteDeSonolencia.titulo}</h3>
        <hr/>
        {this.state.status == 'respondido' ?
          ""
          :
          <form onSubmit={this.edit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Usuarios.TesteDeSonolencia.formulario.HorarioDeInicioDaJornada}:</label>
                  <InputMask required value={this.state.hour_start} maskChar={null} name="hour_start" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'hour_start')} placeholder={this.locale.Usuarios.TesteDeSonolencia.formulario.placeholder.HorarioDeApresentacao} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Usuarios.TesteDeSonolencia.formulario.ComoVoceEstaSeSentindoAgora}?</label>
                  <Select
                    className="form-field-name"
                    name="fatigue"
                    value={this.state.fatigue}
                    searchable={true}
                    placeholder={'Selecionar uma opção'}
                    onChange={this.handleSelectChange.bind(this, 'fatigue')}
                    options={[
                      {value: 'extremely_alert', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.ExtremamenteAlerta},
                      {value: 'very_alert', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.MuitoAlerta},
                      {value: 'alert', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.Alerta},
                      {value: 'fairly_alert', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.RazoavelmenteAlerta},
                      {value: 'neither_alert_sleet', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.NemAlertaNemSonolento},
                      {value: 'signs_sleepiness', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.AlgunsSinaisDeSonolencia},
                      {value: 'sleepy_no_effort', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.SonolentoMasConsigoMeManterAcordado},
                      {value: 'sleepy_some_effort', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.SonolentoPrecisoMeConcentrarParaMeManterAcordado},
                      {value: 'sleepy_great_effort', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.MuitosonolentoMuitoEsforcoParaMeManterAcordadoLutandoComOSono}
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Usuarios.TesteDeSonolencia.formulario.botaoResponder}</button>
              </div>
            </div>
          </form>
        }
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default EmailDrowsinessScheduleTest;


// WEBPACK FOOTER //
// ./src/Components/Users/EmailDrowsinessScheduleTest.js